/**
 * Determines if a page is navigating between significant paths that require UI updates
 * @param currentPath Current path
 * @param newPath New path being navigated to
 * @returns Object with path change information
 */
export var getPathChangeType = function getPathChangeType(currentPath, newPath) {
  if (!currentPath || !newPath) {
    return {
      isChangingMake: false,
      isChangingToGeneric: false,
      isChangingFromGeneric: false,
      isSignificantChange: false
    };
  }
  var currentParts = currentPath.split('/');
  var newParts = newPath.split('/');

  // From a specific make (like /autos/toyota) to generic /autos
  var isChangingToGeneric = currentParts[1] === 'autos' && currentParts.length > 2 && newParts[1] === 'autos' && newParts.length === 2;

  // From generic /autos to a specific make (like /autos/hyundai)
  var isChangingFromGeneric = currentParts[1] === 'autos' && currentParts.length === 2 && newParts[1] === 'autos' && newParts.length > 2;

  // Between different makes (like /autos/toyota to /autos/hyundai)
  var isChangingMake = currentParts[1] === 'autos' && newParts[1] === 'autos' && currentParts.length > 2 && newParts.length > 2 && currentParts[2] !== newParts[2];
  var isSignificantChange = isChangingMake || isChangingToGeneric || isChangingFromGeneric;
  return {
    isChangingMake: isChangingMake,
    isChangingToGeneric: isChangingToGeneric,
    isChangingFromGeneric: isChangingFromGeneric,
    isSignificantChange: isSignificantChange
  };
};

/**
 * Banner caching helper to determine if a banner should be cached
 * @param marketingBanner The marketing banner object
 * @param banner The banner image URL
 * @returns boolean indicating if the banner should be cached
 */
export var shouldCacheBanner = function shouldCacheBanner(marketingBanner, banner) {
  return !!marketingBanner && !!banner;
};